/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDailySummaryDto } from '../models/CreateDailySummaryDto';
import type { ReadDailySummaryDtoApiResponse } from '../models/ReadDailySummaryDtoApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DailySummaryService {

    /**
     * @param requestBody
     * @returns ReadDailySummaryDtoApiResponse Success
     * @throws ApiError
     */
    public static postApiV1DailySummaries(
        requestBody?: CreateDailySummaryDto,
    ): CancelablePromise<ReadDailySummaryDtoApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/daily-summaries',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
